import type { Place } from "../state/types";

type Fact = [string, string];

// Gemeente, wijk en buurt op één regel; woonplaats en CBS-kern apart, want dat
// zijn twee indelingen. Delen ze een naam, dan één regel die dat zegt in plaats
// van dezelfde naam twee keer.
export const placeFacts = (place?: Place | null): Fact[] => {
  if (!place) return [];
  const facts: Fact[] = [];
  const location = [place.municipality, place.district, place.neighbourhood]
    .filter(Boolean)
    .join(" - ");
  if (location) facts.push(["Ligging", location]);
  if (place.city && place.city === place.kern) {
    facts.push(["Woonplaats", `${place.city} (ook de CBS-kern)`]);
    return facts;
  }
  if (place.city) facts.push(["Woonplaats", place.city]);
  if (place.kern) facts.push(["CBS-kern", place.kern]);
  return facts;
};
